import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const TOKEN_KEY = "factskoot_token";

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

/** Download an authenticated PDF endpoint as a blob and trigger browser save.
 *  `path` should be relative to /api (e.g. "/certificates/123/pdf").
 *  If `filename` is not provided, derives a name from the response headers or the path. */
export async function downloadPdf(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  let name = filename;
  if (!name) {
    const cd = res.headers?.["content-disposition"] || "";
    const m = cd.match(/filename="?([^";]+)"?/);
    name = m ? m[1] : path.split("/").filter(Boolean).pop() + ".pdf";
  }
  a.download = name;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    a.remove();
    window.URL.revokeObjectURL(url);
  }, 200);
  return blob;
}

export function formatApiError(input) {
  if (input == null) return "Something went wrong. Please try again.";
  // Accept an AxiosError (or any error) directly — unwrap to its
  // backend `detail` payload first so callers don't have to.
  let detail = input;
  if (input && typeof input === "object") {
    if (input.response && input.response.data) {
      detail = input.response.data.detail
        ?? input.response.data.message
        ?? input.response.data;
    } else if (input.message && !input.msg && !Array.isArray(input)) {
      detail = input.message;
    }
  }
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.detail === "string") return detail.detail;
  return String(detail);
}
